<template>
  <d-page
    :title="$t('roles.page-heading')"
    :searchToggle="searchToggle"
    @closeSearch="handleCloseSearch"
    @submitSearch="handleSubmitSearch"
  >
    <template slot="actions">
      <v-btn
        depressed
        large
        class="mr-3 mb-1 mb-sm-0"
        :class="searchToggle ? 'primary--text' : ''"
        @click="searchToggle = !searchToggle"
      >
        <v-icon left> mdi-tune </v-icon>
        <span class="subtitle-2 text-none">{{
          $t("roles.button.search-toggle")
        }}</span>
      </v-btn>
      <v-btn
        color="success"
        depressed
        large
        @click="handleOpenAddOrEditModal()"
        v-granted="'role:add'"
        class="mb-1 mb-sm-0"
      >
        <v-icon left> mdi-plus </v-icon>
        <span class="subtitle-2 text-none">{{
          $t("roles.button.create-item")
        }}</span>
      </v-btn>
    </template>
    <template slot="search">
      <Search></Search>
    </template>
    <template slot="content">
      <List
        @editItem="handleOpenAddOrEditModal"
        @deleteItem="handleOpenDeleteModal"
      ></List>
      <AddOrEdit
        v-if="openAddOrEditModal"
        :modal="openAddOrEditModal"
        :item="selectedItem"
        @closeModal="handleCloseAddOrEditModal"
        @submitModal="handleSubmitAddOrEditModal"
      ></AddOrEdit>
      <Delete
        v-if="openDeleteModal"
        :modal="openDeleteModal"
        :item="selectedItem"
        @closeModal="handleCloseDeleteModal"
        @submitModal="handleSubmitDeleteModal"
      ></Delete>
    </template>
  </d-page>
</template>

<script>
import List from "./List.vue";
import Search from "./Search.vue";
import AddOrEdit from "./AddOrEdit.vue";
import Delete from "./Delete.vue";

export default {
  components: {
    List,
    Search,
    AddOrEdit,
    Delete,
  },
  data() {
    return {
      searchToggle: false,
      openAddOrEditModal: false,
      openDeleteModal: false,
      selectedItem: null,
    };
  },
  methods: {
    handleCloseSearch() {
      this.$eventBus.$emit("fetchRoles", true);
    },
    handleSubmitSearch() {
      this.$eventBus.$emit("fetchRoles");
    },
    handleOpenAddOrEditModal(item = null) {
      this.openAddOrEditModal = true;
      this.selectedItem = item;
    },
    handleCloseAddOrEditModal() {
      this.openAddOrEditModal = false;
    },
    handleSubmitAddOrEditModal() {
      this.$eventBus.$emit("fetchRoles");
    },
    handleOpenDeleteModal(item = null) {
      this.openDeleteModal = true;
      this.selectedItem = item;
    },
    handleCloseDeleteModal() {
      this.openDeleteModal = false;
    },
    handleSubmitDeleteModal() {
      this.$eventBus.$emit("fetchRoles");
    },
  },
};
</script>
